import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule } from '@spartacus/core'
import { IconModule, SpinnerModule } from '@spartacus/storefront'
import { EbSpinnerModule } from '../spinner/eb-spinner.module'
import { EbModalComponent } from './eb-modal.component'

@NgModule({
  imports: [CommonModule, IconModule, I18nModule, SpinnerModule, EbSpinnerModule],
  declarations: [EbModalComponent],
  exports: [EbModalComponent]
})
export class EbModalModule {}
